import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";

const COLORS = {
  bg: "#FFFDF8",
  card: "#FFFFFF",
  border: "#EADFCB",
  title: "#1A1A1A",
  accent: "#F5C400",
  grid: "#E0E0E0"
};

const quoteData = [
  { name: "Prospects", value: 320 },
  { name: "Requests", value: 240 },
  { name: "Declined", value: 240 }
];

const premiumData = [
  { month: "Jan", revenue: 50000 },
  { month: "Feb", revenue: 60000 },
  { month: "Mar", revenue: 70000 },
  { month: "Apr", revenue: 80000 },
  { month: "May", revenue: 95000 }
];

const Dashboard = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: COLORS.bg,
        p: 3,
        width: "100%"
      }}
    >
      <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ height: 420, p: 2, borderRadius: 3 }}>
            <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
              Customer Details
            </Typography>
            <Box sx={{ height: 320 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={quoteData}>
                  <CartesianGrid strokeDasharray="4 4" vertical={false} />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill={COLORS.accent} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ height: 420, p: 2, borderRadius: 3 }}>
            <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
              Growth Trend
            </Typography>
            <Box sx={{ height: 320 }}>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={premiumData}>
                  <CartesianGrid strokeDasharray="4 4" vertical={false} />
                  <XAxis dataKey="month" />
                  <YAxis domain={[0, "dataMax"]} />
                  <Tooltip />
                  <Line
                    type="linear"
                    dataKey="revenue"
                    stroke={COLORS.accent}
                    strokeWidth={4}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
